import { render } from "./AppStateTag.vue?vue&type=template&id=3223c9b0&ts=true"
import script from "./AppStateTag.vue?vue&type=script&lang=ts"
export * from "./AppStateTag.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/olaria-preco/olaria-preco/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__